var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { when } from 'lit/directives/when.js';
// Components
import { BaseElement } from '@frontend_zz/base-element/BaseElement.js';
import { Icon } from '@frontend_zz/icon/Icon.js';
// Styling
import styles from './ListItem.css.js';
/**
 * @element zz-list-item
 */
export class ListItem extends BaseElement {
    static get styles() {
        return [styles];
    }
    static get scopedElements() {
        return {
            'zz-icon': Icon,
        };
    }
    updated() {
        const { icon } = this;
        if (icon) {
            this.setAttribute('has-icon', '');
        }
        else {
            this.removeAttribute('has-icon');
        }
    }
    render() {
        const { icon } = this;
        return html `
            <li class="item">
                ${when(icon, () => html `<zz-icon class="icon" type=${icon} size="s"></zz-icon>`)}
                <slot></slot>
            </li>
        `;
    }
}
__decorate([
    property()
], ListItem.prototype, "icon", void 0);
